const ferries = {
  ferry: "Transportar", // translated
  ferries: "ferries", // translated
  selectOriginPort: "Seleccione el Puerto de origen", // translated
  selectDestPort: "Seleccione el puerto de destino", // translated
  continue: "Continuar", // translated
  viewTimetables: "Ver horarios", // translated
  operator: "Operador", // translated
  cabin: "Cabina", // translated
  cabins: "Cabañas", // translated
  place: "Lugar", // translated
  places: "Lugares", // translated
  seat: "Asiento", // translated
  seats: "Asientos", // translated
  seating: "Asientos", // translated
  deckSpace: "Espacio en cubierta", // translated
  compulsory: "obligatorio", // translated
  departure: "Partida", // translated
  total: "Total", // translated
  back: "Atrás", // translated
  next: "Próximo", // translated
  duration: "Duración", // translated
  return: "Devolver", // translated
  prebook: "Reservar de antemano", // translated
  travelInfo: "Información de viaje", // translated
  book: "Libro", // translated
  adults: "Adultos", // translated
  child: "Niño", // translated
  seniors: "personas mayores", // translated
  senior: "Sénior", // translated
  to: "a", // translated
  passenger: "Pasajero", // translated
  details: "Detalles", // translated
  currencyForTickets: "La moneda para estos boletos será", // translated
  seatsError: "El número de pasajeros no es igual a la capacidad.", // translated
  title: "Título", // translated
  firstName: "Nombre de pila", // translated
  lastName: "Apellido", // translated
  email: "Correo electrónico", // translated
  phone: "Teléfono", // translated
  dateOfBirth: "Fecha de nacimiento", // translated
  placeOfBirth: "Lugar de nacimiento", // translated
  groupLeader: "Lider de grupo", // translated
  isRequired: "Se requiere", // translated
  charactersOnly: "Solo personajes", // translated
  latinCharactersAndSpacesOnly: "Caracteres y espacios latinos únicamente", // translated
  validEmail: "No es un correo electrónico válido", // translated
  atLeastOneAdult: "Se requiere al menos 1 adulto.", // translated
  atLeastOneSenior: "Se requiere al menos 1 persona mayor.", // translated
  toastAlert: "Corrija todos los errores en los formularios a continuación.", // translated
  backToFerriesList: "Volver a la lista de ferries", // translated
  bestPrice: "Mejor precio", // translated
  fastest: "Lo más rápido", // translated
  beforeDeparture: "Antes de la salida", // translated
  perPerson: "por persona", // translated
  notAvailableForOnlineBooking: "No disponible para reservas online", // translated
  hurryLimitedAvailability: "¡Apresúrate! Disponibilidad limitada", // translated
  berth: "Atracar", // translated
  berths: "Literas", // translated
  sumOfSelectionNotEqualToPersons: "La suma de su selección no es igual al número de pasajeros.", // translated
  attemptToBook: "Ha intentado reservar un total de", // translated
  seatsWhenYouHave: "asientos cuando tienes", // translated
  passengersTravelling: "pasajeros que viajan", // translated
  withReturn: "con billetes de vuelta", // translated
  pleaseCorrectYourSelection: "Por favor corrija su selección", // translated
  pleaseSelectUpTo: "Por favor seleccione hasta", // translated
  accommodationTypes: "tipos de alojamiento", // translated
  selectionPrices: "Precios de selección", // translated
  yourCurrentTicket: "Su tipo de billete actual es", // translated
  upgradeTo: "Actualizar a", // translated
  wouldYouLikeToUpgrade: "¿Le gustaría mejorar su tipo de boleto?", // translated
  backToTicketTypes: "Volver a Tipos de Entradas", // translated
  originPort: "Puerto de origen", // translated
  destinationPort: "Puerto de destino", // translated
  outboundDate: "Fecha de salida", // translated
  inboundDate: "Fecha de entrada", // translated
  passengers: "Pasajeros", // translated
  hasReturn: "Tiene retorno", // translated
  passportNumber: "Número de pasaporte", // translated
  passportExpiryDate: "fecha de vencimiento del pasaporte", // translated
  passportPlaceOfIssue: "Lugar de emisión del pasaporte", // translated
  passportStartDate: "Fecha de inicio del pasaporte", // translated
  cityCode: "Código de ciudad", // translated
};

export default ferries;
